export default [
  {
    fullName: 'Евгений Лобанков',
    jobTitle: 'Директор по развитию',
    description: 'МФТ Платформа',
    photo: require('@/assets/speakers/Евгений Леонов.jpg')
  },
  {
    fullName: 'Владимир Никончук',
    jobTitle: 'Пресейл-менеджер',
    description: 'Холдинг Т1',
    photo: require('@/assets/speakers/Никончук (1).jpg')
  }
]
